import {registerLocaleData} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import {LOCALE_ID, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgxCaptchaModule} from 'ngx-captcha';
import {NgxMaskModule} from 'ngx-mask';
import {NgxPaginationModule} from 'ngx-pagination';

// PRIME NG
import {AutoCompleteModule} from 'primeng/autocomplete';
import {ButtonModule} from 'primeng/button';
import {DialogModule} from 'primeng/dialog';
import {DropdownModule} from 'primeng/dropdown';
import {FileUploadModule} from 'primeng/fileupload';
import {InputTextModule} from 'primeng/inputtext';
import {MessageModule} from 'primeng/message';
import {MessagesModule} from 'primeng/messages';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {SelectButtonModule} from 'primeng/selectbutton';
import {ToastModule} from 'primeng/toast';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {LoginComponent} from './pages/login/login.component';
import {RecuperarSenhaVerificacaoComponent} from './pages/recuperar-senha/recuperar-senha-verificacao/recuperar-senha-verificacao.component';
import {RecuperarSenhaComponent} from './pages/recuperar-senha/recuperar-senha.component';
import {SelecionarBeneficiarioComponent} from './pages/selecionar-beneficiario/selecionar-beneficiario.component';
import {NovaSolicitacaoComponent} from './pages/solicitacoes/nova-solicitacao/nova-solicitacao.component';
import {SolicitacaoComponent} from './pages/solicitacoes/solicitacao/solicitacao.component';
import {SolicitacoesComponent} from './pages/solicitacoes/solicitacoes.component';
import {ErrorInterceptor} from './security/error.interceptor';
import {JwtInterceptor} from './security/jwt.interceptor';
import {AutenticacaoService} from './services/autenticacao.service';
import {FooterComponent} from './shared/layout/footer/footer.component';
import {FooterGenericComponent} from './shared/layout/footer-generic/footer-generic.component';
import {HeaderComponent} from './shared/layout/header/header.component';
import {HeaderGenericComponent} from './shared/layout/header-generic/header-generic.component';
import {ConfirmDialogModule} from 'primeng/confirmdialog';

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HeaderGenericComponent,
    FooterComponent,
    FooterGenericComponent,
    LoginComponent,
    RecuperarSenhaComponent,
    SelecionarBeneficiarioComponent,
    SolicitacoesComponent,
    NovaSolicitacaoComponent,
    SolicitacaoComponent,
    RecuperarSenhaVerificacaoComponent
  ],
  imports: [
    AutoCompleteModule,
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    ButtonModule,
    DialogModule,
    DropdownModule,
    FileUploadModule,
    FormsModule,
    HttpClientModule,
    InputTextModule,
    MessagesModule,
    MessageModule,
    ConfirmDialogModule,
    NgxMaskModule.forRoot(),
    NgxPaginationModule,
    NgxCaptchaModule,
    ProgressSpinnerModule,
    ReactiveFormsModule,
    SelectButtonModule,
    ToastModule,
  ],
  providers: [
    FileUploadModule,
    {provide: LOCALE_ID, useValue: 'pt-BR'},
    AutenticacaoService,
    {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
  ],

  bootstrap: [AppComponent]
})
export class AppModule {
}
